import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import VueSpeedometer from 'vue-speedometer'
import { useStore } from 'vuex'
import commonPopup from 'components/general/common-popup/index.vue'
import misc from 'src/utils/helper/misc'

import QuestionMarkInfoIcon from '../../icons/foundry-health/question-mark-info/index.vue'
import AgreementIcon from '../../icons/foundry-health/agreement/index.vue'
import ArrowIcon from '../../icons/foundry-health/right-arrow/index.vue'
import { adobeCjaEventEmitter } from '../../../../../../modules/adobe-cja/utils'
import { CJA_EVENTS, LINK_CATEGORIES, LINK_SECTION, LINK_NAMES, LINK_TYPES } from '../../../../../../modules/adobe-cja/constants'

export default {
  components: {
    VueSpeedometer,
    QuestionMarkInfoIcon,
    AgreementIcon,
    ArrowIcon,
    commonPopup
  },
  emits: ['toggleSideBar'],
  setup(props, { emit }) {
    const store = useStore();
    const router = useRouter();
    const showPermissionNeededPopup = ref(false);

    const AllhealthReportChallenge = computed(() => {
      return store.getters['healthReport/getHealthReportChallenge'];
    });
    const completedChallenge = computed(() => {
      return store.getters['healthReport/getHealthReportChallenge'].filter(item => item.taskStatus == 'completed').length;
    });

    const incompleteChallenge = computed(() => {
      const healthReportChallenge = store.getters['healthReport/getHealthReportChallenge'];
      return healthReportChallenge.find((item) => item.taskStatus == 'inComplete') || [];
    });

    const changeRoute = (item) => {
      if (!misc.isFoundryHaveModulePermission(store.getters['profile/sessionFoundryId'], item.taskRoute)) {
        showPermissionNeededPopup.value = true;
        return;
      }

      if (item.taskModule === 'Agreement') {
        adobeCjaEventEmitter({
          event: CJA_EVENTS.LINK_CLICK,
          links: {
            linkCategory: LINK_CATEGORIES.SIGN_LATEST_AGREEMENT,
            linkSection: LINK_SECTION.DASHBOARD,
            linkName: LINK_NAMES.SIGN_LATEST_AGREEMENT,
            linkType: LINK_TYPES.LINK_TEXT
          }
        })
      }

      router.push({
        name: item.taskRoute,
        params: {
          id: store.getters['profile/sessionFoundryId'],
        }
      })
    }

    const speedometerStyles = {
      width: '250px',
      height: '150px',
    }

    const toggleSideBar = () => {
      emit('toggleSideBar');
      adobeCjaEventEmitter({
        event: CJA_EVENTS.LINK_CLICK,
        links: {
          linkCategory: LINK_CATEGORIES.VIEW_DETAILS_FOUNDRY_HEALTH,
          linkSection: LINK_SECTION.DASHBOARD,
          linkName: LINK_NAMES.VIEW_DETAILS_FOUNDRY_HEALTH,
          linkType: LINK_TYPES.LINK_TEXT
        }
      })
    }
    const minScore = computed(() => store.getters['healthReport/getMinScore'])
    const maxScore = computed(() => store.getters['healthReport/getMaxScore'])
    const visibilityScore = computed(() => store.getters['healthReport/getVisibilityScore'])

    const VisibilityScoreVal = computed(() => {
      return Math.min(Math.max(visibilityScore.value, minScore.value), maxScore.value);
    });

    const closePermissionNeededPopup = () => {
      showPermissionNeededPopup.value = false;
    }

    return {
      speedometerStyles,
      toggleSideBar,
      minScore,
      maxScore,
      visibilityScore,
      changeRoute,
      incompleteChallenge,
      AllhealthReportChallenge,
      VisibilityScoreVal,
      showPermissionNeededPopup,
      closePermissionNeededPopup,
      completedChallenge
    }
  }
}
